import React, { Component } from "react";

import ReCAPTCHA from "react-google-recaptcha";

import AnmeldungService from "../services/AnmeldungService";
import CenteredLoader from "./CenteredLoader";


export default class AnmeldungSportlerSubmit extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isSaving: false,
            isDatenschutzAccepted: false,
            errorMessage: null,
            captcha: null
        };

        this.recaptchaRef = React.createRef();
    }

    onFinish = () => {
        console.log("Speichere Anmeldedaten auf Server...");
        this.setState({ isSaving: true });

        const request = {
            anmeldezeitpunkt: new Date(),
            email: this.props.daten.mail,
            captcha: this.state.captcha,
            teilnehmer: [{
                disziplinId: Number(this.props.daten.wettbewerb.value),
                vorname: this.props.daten.vorname,
                nachname: this.props.daten.nachname,
                geschlecht: this.props.daten.geschlecht.value,
                jahrgang: Number(this.props.daten.jahrgang),
                verein: this.props.daten.verein,
                verband: this.props.daten.verband,
                startpass: this.props.daten.startpass,
            }]
        }

        const eventId = Number(this.props.eventId);

        this.setState({ isSaving: true, errorMessage: null });

        AnmeldungService.storeAnmeldung(eventId, request).then(res => {
            this.props.onSuccess();
        }).catch(err => {
            this.setState({ errorMessage: err.response.data, isSaving: false, captcha: null })
            this.recaptchaRef.current.reset();
        })

    }

    onCaptchaChange = (captchaResult) => {
        this.setState({captcha: captchaResult});
    }

    render() {

        const mitStartpass = this.props.mitStartpass || false;

        return (
            <form className="jh-content-form">
                <div className="form-row">
                    <div className="form-group col-md-6">
                        <label htmlFor="inputVorname">Vorname</label>
                        <p>{this.props.daten.vorname}</p>
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="inputNachname">Nachname</label>
                        <p>{this.props.daten.nachname}</p>
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-md-12">
                        <label htmlFor="inputMail">E-Mail-Adresse</label>
                        <p>{this.props.daten.mail}</p>
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-md-6">
                        <label htmlFor="inputJahrgang">Jahrgang</label>
                        <p>{this.props.daten.jahrgang}</p>
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="inputGeschlecht">Geschlecht</label>
                        <p>{this.props.daten.geschlecht.label}</p>
                    </div>
                </div>
                <div className="form-row">
                    <div className={"form-group " + (mitStartpass ? " col-md-6" : "col-md-8")}>
                        <label htmlFor="inputVerein">Verein/Team</label>
                        <p>{this.props.daten.verein}</p>
                    </div>
                    {mitStartpass && <div className="form-group col-md-4">
                        <label htmlFor="inputStartpass">Startpass</label>
                        <p>{this.props.daten.startpass || "-"}</p>
                    </div>}
                    <div className={"form-group " + (mitStartpass ? " col-md-2" : "col-md-4")}>
                        <label htmlFor="inputVerband">Verband</label>
                        <p>{this.props.daten.verband || "-"}</p>
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group col-md-12">
                        <label>Wettbewerb</label>
                        <p>{this.props.daten.wettbewerb.label}</p>
                    </div>
                </div>               

                <div className="form-check">
                    <input className="form-check-input" type="checkbox" checked={this.state.isDatenschutzAccepted} id="checkboxDatenschutz"
                        onChange={() => this.setState((prevState) => ({ isDatenschutzAccepted: !prevState.isDatenschutzAccepted }))}
                        disabled={this.state.isSaving} />
                    <label className="form-check-label" htmlFor="checkboxDatenschutz">
                        Ich habe die Hinweise zum Datenschutz gelesen und akzeptiere, dass die angegebenen Daten zur Durchführung der Veranstaltung verwendet werden.
                </label>
                </div>

                <div className="form-check jh-captcha">
                    <ReCAPTCHA
                        sitekey="6Lccw44UAAAAAF1bK2iZ8bXOdiSLW2JDy1QopDSJ"
                        onChange={this.onCaptchaChange}
                        ref={this.recaptchaRef}
                    />
                </div>

                <div className="form-row jh-space-top-mid">
                    {this.state.errorMessage != null && <div className="form-group col-md-12"><label style={{ color: "#fe2360" }}>Fehler beim Speichern der Anmeldung: {this.state.errorMessage}</label></div>}

                    <div className="form-group col-md-12">

                        <CenteredLoader isVisible={this.state.isSaving} text="Anmeldung wird gespeichert..." />

                        {!this.state.isSaving && <button className="btn btn-primary btn-block jh-btn" type="button" disabled={!(this.state.isDatenschutzAccepted && this.state.captcha)}
                            onClick={this.onFinish}>Anmeldung abschließen</button>}

                    </div>
                </div>
            </form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/AnmeldungSportlerSubmit.js